// extracted by mini-css-extract-plugin
module.exports = {"base":"ReportHeader_base__vWzc1","categories":"ReportHeader_categories__o7txG"};